import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getUserProfileAsync } from "../../reducers/user-reducers";
 
const AccountSettingNav = () => {
  // const [userProfile, setUserProfile] = useState(null);
  const dispatch = useDispatch();
  const userProfile = useSelector((state) => state.user.userProfile);
  const location = useLocation();
  const [userActive, setUserActive] = useState("");
 
  useEffect(() => {
    dispatch(getUserProfileAsync());
  }, []);
  
  useEffect(() => {
    switch (location.pathname) {
      case "/accountsetting/manageteams":
        setUserActive("Manage Teams");
        break;
      case "/accountsetting/billingsubscription":
        setUserActive("Billing & Subscription");
        break;
      case "/accountsetting/preferences":
        setUserActive("Preferences");
        break;
      default:
        setUserActive("Profile");
    }
  }, [location.pathname]);
 
  return (
    <ul
      className="authoringNav"
      style={{ marginBottom: "-2.438rem", marginLeft: "3.75rem" }}
    >
      <li className="me-4">
        <NavLink
          className={`h6 text-gray-100 ${
            userActive === "Profile" ? "active" : ""
          }`}
          to="/accountsetting/profile"
        >
          Profile
        </NavLink>
      </li>
 
      {userProfile &&
        (userProfile.roleName === "Super Admin" ||
          userProfile.switchedRoleName === "Admin") && (
          <>
            <li className="me-4">
              <NavLink
                className={`h6 text-gray-100 ${
                  userActive === "Manage Teams" ? "active" : ""
                }`}
                to="/accountsetting/manageteams"
              >
                Manage Teams
              </NavLink>
            </li>
            {/* {(userProfile.roleName === "Super Admin" || userProfile.switchedRoleName === "Admin") && ( */}
            <li className="me-4">
              <NavLink
                className={`h6 text-gray-100 ${
                  userActive === "Billing & Subscription" ? "active" : ""
                }`}
                to="/accountsetting/billingsubscription"
              >
                Billing & Subscription
              </NavLink>
            </li>{" "}
            {/* )} */}
          </>
        )}
 
      <li className="me-4">
        <NavLink
          className={`h6 text-gray-100 ${
            userActive === "Preferences" ? "active" : ""
          }`}
          to="/accountsetting/preferences"
        >
          Preferences
        </NavLink>
      </li>
    </ul>
    // <ul className='authoringNav'>
    //     {/* exact */}
    //     <li className='me-4'>
    //         <NavLink className='h6 text-gray-100' to="/accountsetting/profile">Profile</NavLink>
    //     </li>
    //     {/* <li className='me-4'>
    //         <NavLink className='h6 text-gray-100' to="/accountsetting/users">Users</NavLink>
    //     </li> */}
    //     <li className='me-4'>
    //         <NavLink className='h6 text-gray-100' to="/accountsetting/manageteams">Manage Teams</NavLink>
    //     </li>
 
    //     <li className='me-4'>
    //         <NavLink className='h6 text-gray-100' to="/accountsetting/billingsubscription">Billing & Subscription</NavLink>
    //     </li>
 
    //     <li className='me-4'>
    //         <NavLink className='h6 text-gray-100' to="/accountsetting/preferences">Preferences</NavLink>
    //     </li>
    // </ul>
  );
};
 
export default AccountSettingNav;

